<div class="input-group" [class.has-danger]="control.touched && !control.valid && !control.disabled">
  <span class="input-group-text">$</span>
  <input id="combined-input" class="form-control" size="16" type="text" [formControl]="control" numbersOnly
         [decimal]="allowDecimal">
  <span *ngIf="showDecimal" class="input-group-text">.00</span>
</div>
